// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

const VALID_PAGE_PREFS = [
  'integration',
  'method',
  'html-or-react',
  'language',
  'lang-ios',
  'integration-path',
  'pricing-style',
  'testing-method',
  'tax-calculation',
  'type',
  'integration-country',
  'ui',
  'platform',
  'terminal-sdk-platform',
  'reader-type',
  'payment-integration-type',
  'nameserver-provider', // Used for Checkout custom domains docs
  'verify-with-terminal-or-web',
  'connect-payment-integration-type',
  'connect-charge-type',
  'connect-account-type',
  'account',
];

export const Page: MarkdocTagRegistration = {
  tag: 'page',
  component: 'Page',
  attributes: {
    prefs: {
      type: Object,
      required: true,
      description: 'Used to persist user selections to a cookie',
    },
    title: {
      type: String,
      localizable: true,
      description: 'The title of the tab.',
    },
    badge: {
      type: Object,
      localizable: ['label'],
      description:
        'An optional badge to display to the right of the tab title.',
    },
  },
  validate(node, config) {
    const prefs: {[key: string]: string} = (node.attributes.prefs: any);
    const invalidPrefs = Object.keys(prefs).filter(
      (pref) => !VALID_PAGE_PREFS.includes(pref),
    );

    if (invalidPrefs.length > 0) {
      return [
        {
          id: 'invalid-pref',
          level: 'critical',
          message: `The prefs: ${invalidPrefs.join(
            ', ',
          )} are not valid. Add them to the list of VALID_PAGE_PREFS in Page.markdoc.js.`,
        },
      ];
    }

    return [];
  },
};
